import { createSelector } from 'reselect';

const loader = state => {
    if (!state) return null;
    if (typeof state.get === 'function') {
        return state.get('loader');
    }
    return state.loader || null;
};

const getCurrentLoaderCount = () => createSelector(loader, state => (state ? state.toJS().count : 0));

export default getCurrentLoaderCount;
